import React from 'react';
import { useNavigate } from 'react-router-dom';
import heygenVideo from '../../assets/videos/short_video.mp4';
import './hero.scss';

const stats = [
    { value: '1,250+',    label: 'Global Customers'    },
    { value: '32,480+',   label: 'Shipments Completed' },
    { value: '1.2M Tons', label: 'Quantity Imported'   },
    { value: '85+',       label: 'Countries Exported'  },
];

const Hero = () => {
    const navigate = useNavigate();

    return (
        <section className="dp-hero">
            {/* Full-screen autoplay background video */}
            <video
                className="dp-hero__bg-video"
                src={heygenVideo}
                autoPlay
                muted
                loop
                playsInline
            />
            <div className="dp-hero__overlay" />
            <div className="dp-hero__grid" />
            <div className="dp-hero__deco dp-hero__deco--1" />
            <div className="dp-hero__deco dp-hero__deco--2" />
            <div className="dp-hero__deco dp-hero__deco--3" />

            <div className="dp-hero__body">
                <div className="dp-hero__content">
                    <div className="dp-hero__badge">
                        <span className="badge-star">✦</span>
                        <span className="badge-text">Celebrating 10 Years of Excellence</span>
                        <span className="badge-star">✦</span>
                    </div>
                    <h1 className="dp-hero__title">
                        India&apos;s Trusted{' '}
                        <span className="highlight">Chemical Supplier</span>
                    </h1>
                    <p className="dp-hero__subtitle">
                        Leading importers, exporters &amp; suppliers of Solvents,
                        Petrochemicals &amp; Pharmaceutical Products across 85+ countries.
                    </p>
                    <div className="dp-hero__actions">
                        <button className="btn-primary-dp" onClick={() => navigate('/products')}>
                            Explore Products
                        </button>
                        <button className="btn-outline-dp" onClick={() => navigate('/contact')}>
                            Get in Touch
                        </button>
                    </div>
                </div>
            </div>

            <div className="dp-hero__stats">
                <div className="stats-inner">
                    {stats.map((s, i) => (
                        <div className="stat-item" key={i}>
                            <span className="stat-value">{s.value}</span>
                            <span className="stat-label">{s.label}</span>
                        </div>
                    ))}
                </div>
            </div>

            <div className="dp-hero__scroll">
                <span className="scroll-line" />
                <span className="scroll-text">Scroll</span>
            </div>
        </section>
    );
};

export default Hero;
